import React from 'react'
import './WeatherStation.css'

/**
 * Live weather-station widget from Holfuy (holfuy.com). Embeds the station's
 * real-time wind/temperature readout via the official widget iframe:
 *   https://widget.holfuy.com/?station={id}&su={speed}&t={temp}&lang=en&mode={mode}
 *
 * Holfuy's generated embed uses fixed pixel sizes and specific iframe attributes
 * (marginheight/marginwidth/scrolling="no"), which we mirror here. Mode presets:
 *   - "mini"     180x120  (compact, matches Holfuy's sample embed)
 *   - "detailed" 580x250  (wind + temp + gust + cloud base)
 *   - "average"  260x120
 *   - "winds"    260x150
 * Defaults suit UK club use (km/h, Celsius).
 */
const MODE_SIZES = {
  mini: { width: 180, height: 120 },
  average: { width: 260, height: 120 },
  winds: { width: 260, height: 150 },
  detailed: { width: 580, height: 250 },
}

function WeatherStation({
  stationId,
  name,
  mode = 'mini',
  speedUnit = 'km/h',
  tempUnit = 'C',
  width,
  height,
}) {
  if (!stationId) return null

  const size = MODE_SIZES[mode] || MODE_SIZES.mini
  const w = width ?? size.width
  const h = height ?? size.height

  const params = new URLSearchParams({
    station: String(stationId),
    su: speedUnit,
    t: tempUnit,
    lang: 'en',
    mode,
  })
  const src = `https://widget.holfuy.com/?${params.toString()}`
  const stationUrl = `https://holfuy.com/en/weather/${stationId}`

  return (
    <div className="weather-station">
      <iframe
        title={`Live weather at ${name || 'the weather station'}`}
        src={src}
        width={w}
        height={h}
        frameBorder="0"
        marginHeight="1"
        marginWidth="1"
        scrolling="no"
        loading="lazy"
        style={{ width: w, height: h, border: 0, maxWidth: '100%' }}
      />
      <p className="weather-station-credit">
        Live data from the{' '}
        <a href={stationUrl} target="_blank" rel="noopener noreferrer">
          {name ? `${name} Holfuy station` : 'Holfuy weather station'}
        </a>
        . Readings are indicative - always assess conditions on the hill.
      </p>
    </div>
  )
}

export default WeatherStation
